<template>
  <div v-if="item">
    <h2>ID: #{{ item.id }}</h2>
    <div class="row">
      <div class="col-12 col-md-12">
        <fg-input
          type="text"
          label="Тема письма"
          v-model="item.subject"
        ></fg-input>

        <div class="row">
          <div class="col-6 col-md-4 m-auto">
            <label>Лого</label>
            <div class="draw-image">
              <img :src="item.logo ? item.logo : ''" alt="" />
              <input
                :ref="'logo'"
                :id="'logo'"
                accept="image/*"
                type="file"
                @change="handleFileUpload"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-8 m-auto">
            <label>Баннер</label>
            <div class="draw-image">
              <img :src="item.image ? item.image : ''" alt="" />
              <input
                :ref="'image'"
                :id="'image'"
                accept="image/*"
                type="file"
                @change="handleFileUpload"
              />
            </div>
          </div>
        </div>

        <fg-input type="text" label="Заголовок" v-model="item.title"></fg-input>

        <textarea class="form-control mb-4" v-model="item.text"></textarea>

        <hr/>
        <images/>
        <hr/>


        <div class="row">
          <div class="col-12 col-md-8 m-auto">
            <label>Фасад здания</label>
            <div class="draw-image">
              <img :src="item.image_build ? item.image_build : ''" alt="" />
              <input
                :ref="'image_build'"
                :id="'image_build'"
                accept="image/*"
                type="file"
                @change="handleFileUpload"
              />
            </div>
          </div>
        </div>

        <fg-input type="text" label="Адрес сайта" v-model="item.url"></fg-input>
        <fg-input
          type="text"
          label="Контактный номер телефона"
          v-model="item.phone"
        ></fg-input>
        <fg-input
          type="text"
          label="Контактный Email"
          v-model="item.email"
        ></fg-input>
        <fg-input type="text" label="Адрес" v-model="item.address"></fg-input>

        <hr />
        <h4>Обязательно</h4>

        <fg-input
          type="text"
          label="Откуда отправить (почта)"
          v-model="item.username"
        ></fg-input>
        <fg-input
          type="text"
          label="Пароль от почты"
          v-model="item.password"
        ></fg-input>
        <fg-input type="text" label="Порт почты" v-model="item.port"></fg-input>
        <fg-input
          type="text"
          label="Сервер почты"
          v-model="item.smtp"
        ></fg-input>

        <button
          class="btn btn-sm btn-success btn-icon mt-4 mr-3"
          @click="updateItem"
        >
          <span class="ti-save"></span>
          Сохранить
        </button>

        <button class="btn btn-sm btn-success btn-icon mt-4" @click="sendMail">
          <span class="ti-"></span>
          Отправить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/**Меняю добавление модалку */
export default {
  data: () => ({
    cardLink: "admin/news/card",
    cardSetLink: "admin/news/update",
    cardSendLink: "admin/news/send",
    item: null,
  }),

  props: ["id"],
  created() {
    this.getItem();
  },
  methods: {
    async handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        if (file.size > 51000000) {
          this.$notify({
            title: "Ошибка",
            message: "Файл более 50 мб. весит",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error",
          });
          return false;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        await reader.addEventListener("load", () => {
          try {
            let MAX_WIDTH = 1920;
            let img = document.createElement("img");
            img.src = reader.result;
            img.onload = () => {
              let canvas = document.createElement("canvas");
              let width = img.width;
              let height = img.height;
              let newHeight = height;
              let newWidth = width;
              let ctx = canvas.getContext("2d");
              if (width > MAX_WIDTH) {
                newHeight = (MAX_WIDTH * height) / width;
                newWidth = MAX_WIDTH;
              }
              canvas.height = newHeight;
              canvas.width = newWidth;
              ctx.drawImage(img, 0, 0, newWidth, newHeight);

              this.item[event.target.id] = canvas.toDataURL("image/jpeg");
            };
          } catch (e) {
            this.item[event.target.id] = reader.result;
          }
        });
      }
    },
    getItem() {
      this.$loading(true);
      if (this.id) {
        this.$http
          .get(this.cardLink, {
            params: {
              id: this.id,
            },
          })
          .then((response) => {
            this.item = response.data;
          })
          .catch(() => {})
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
              this.$loading(false);
            }, 400);
          });
      }
    },
    updateItem() {
      this.loading = true;
      this.$loading(true);
      this.$http
        .put(this.cardSetLink, this.item)
        .then((response) => {
          this.$notify({
            title: "Успешно",
            message: "Сохранено",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((error) => {
          errorNotify(error, this);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.$loading(false);
          }, 400);
        });
    },
    sendMail() {
      this.loading = true;
      this.$loading(true);
      this.$http
        .post(this.cardSendLink, this.item)
        .then((response) => {
          this.$notify({
            title: "Успешно отправлено",
            message: "Сохранено",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            title: "Вы уже отправили данное сообщение",
            message: "Уже отправлено",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "warning",
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.$loading(false);
          }, 400);
        });
    },
  },
};
</script>
<style lang="scss">
.draw-image {
  position: relative;
  height: 0;
  padding-top: 100%;
  overflow: hidden;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  margin-bottom: 30px;
  input {
    z-index: 9;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  img {
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
}
</style>
